import { render, staticRenderFns } from "./receiveDataProcessing.vue?vue&type=template&id=935987c6&scoped=true"
import script from "./receiveDataProcessing.vue?vue&type=script&lang=js"
export * from "./receiveDataProcessing.vue?vue&type=script&lang=js"
import style0 from "./receiveDataProcessing.vue?vue&type=style&index=0&id=935987c6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "935987c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('935987c6')) {
      api.createRecord('935987c6', component.options)
    } else {
      api.reload('935987c6', component.options)
    }
    module.hot.accept("./receiveDataProcessing.vue?vue&type=template&id=935987c6&scoped=true", function () {
      api.rerender('935987c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/collectionCenter/Order/receiveDataProcessing.vue"
export default component.exports